import { useLocation } from "react-router-dom";
import { AiOutlineMenu } from "react-icons/ai";
import "./style.css";
import { useContext } from "react";
import { DasboardContext } from "../../context/dashboard-context";

const Breadcrumb = ({ showPath, id }) => {
  const location = useLocation();
  const path = location.pathname;

  const { sidebarOpen, setSidebarOpen, userInfo } = useContext(DasboardContext);

  const pathMap = {
    "/": "Ana Sayfa",
    "/homepage": "Ana Sayfa",
    "/devices": "Cihazlar",
    "/device-list": "Cihaz Listesi",
    "/alarms": "Alarm Listesi",
    "/user-list": "Kullanıcılar",
    "/organisation": "Organizasyon",
    "/login-detail": "Ayarlar",
    "/activities": "Aktiviteler",
  };

  const currentPathName = pathMap[path] || path.substring(1).toUpperCase();

  return (
    <div className={`breadcrumb-wrapper ${sidebarOpen ? "" : "close"}`}>
      <div>
        <AiOutlineMenu onClick={() => setSidebarOpen(!sidebarOpen)} />
        {showPath !== "show" && <p>{currentPathName}</p>}
        {id && <p>{id.suiteName}</p>}
      </div>
      <div>
        <p>Hoşgeldiniz, {userInfo?.username}.</p>
      </div>
    </div>
  );
};

export default Breadcrumb;
